export class HistoricalFulfillmentTime {
    constructor(stats) {
        this.statsByMethod = new Map(stats
            // Require at least 10 orders to have reliable stats for a fulfillment method. After the A/B test consider moving this to the backend.
            .filter((s) => s.count >= 10)
            // Hide estimates of 90+ minutes — unreliable outliers not worth surfacing to customers.
            .filter((s) => s.estimatedMinutesLow < 90 && s.estimatedMinutesHigh < 90)
            // Hide delivery estimates with a suspiciously low floor — assumed to be a computation failure.
            .filter((s) => !(s.fulfillmentMethod === "Delivery" && s.estimatedMinutesLow <= 5))
            .map((s) => [
            s.fulfillmentMethod,
            {
                median: s.estimatedMinutes,
                low: s.estimatedMinutesLow,
                high: s.estimatedMinutesHigh,
            },
        ]));
    }
    getData(method) {
        var _a;
        if (method === null)
            return null;
        const key = method === "NoContactDelivery" ? "Delivery" : method;
        return (_a = this.statsByMethod.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    get hasData() {
        return this.statsByMethod.size > 0;
    }
    getMedianMinutes(method) {
        var _a, _b;
        return (_b = (_a = this.getData(method)) === null || _a === void 0 ? void 0 : _a.median) !== null && _b !== void 0 ? _b : null;
    }
    getEstimatedRange(method) {
        const data = this.getData(method);
        if (data === null)
            return null;
        return { low: data.low, high: data.high };
    }
}
